import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "./Layout/Layout";
import { useForm } from "react-hook-form";
import { Form, Button } from "semantic-ui-react";
import { API_BASE_URL} from "../constants/api";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import {TextField} from "@mui/material";
import Select from "react-select";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


import {
  getValidatedCustomerNumber,
  addUserDetails,
  addIdNumber,
  newSetRegistrationType,
  addNewUserDetails,
  addCustomerValidateDetails,
  addIdType,
} from "../redux/actions/registerCustomerAction";

export const MPSValidation = () => {
  const handleClose = () => setShow(false);
  const dummyData = useSelector((state) => state.addNewUserDetailsReducer.newUserDetailsForm); 
  const {register,handleSubmit,formState: { errors },} = useForm();

  const ID_Type = useSelector((state) => state.addNewUserDetailsReducer.idType);
  const ID_Name = useSelector((state) => state.addNewUserDetailsReducer.idName);

  const reputableDetails = useSelector((state) => state.addNewReputablePersonDetails.reputableDetails);

  const customerDetails = useSelector((state) => state.addNewUserDetailsReducer.validateCustomerDetails);
  const id_Num = customerDetails !== null ? customerDetails.id_Num : null;
  
  const cus_Num = customerDetails !== null ? customerDetails.cus_Num : null;
  const id_type = ID_Type !== null ? ID_Type : null;
  const id_Name = ID_Name !== null ? ID_Name : null;

  const fName = dummyData !== null ? dummyData.firstName : null;
  const lName = dummyData !== null ? dummyData.lastName : null;
  const dob = dummyData !== null ? dummyData.dateOfBirth : null;
  const displaydob = dummyData !== null ? dummyData.displaydateOfBirth : null;


  const [customerNumber, setCustomerNumber] = useState(cus_Num !== undefined ? cus_Num : "");
  const [idType, setIDType] = useState(id_type !== null ? id_type : "");
  const [idNumber, setIdNumber] = useState(id_Num !== undefined ? id_Num : "");
  const [selectedIDType, setSelectedIDType] = useState(null);
  const [idName, setIDName] = useState(id_Name !== null ? id_Name : "");

// Add hooks for First Name, Last Name, and Date of Birth
  const [firstName, setFirstName] = useState(fName !== null ? fName : "");
  const [lastName, setLastName] = useState(lName !== null ? lName : "");
  const [dateOfBirth, setDateOfBirth] = useState(dob !== null ? dob : "");
  const [displayDOB, setDisplayDOB] = useState(displaydob !== null ? displaydob : "");
  

  const [selectedRegistrationType, setSelectedRegistrationType] = useState(reputableDetails !== null
      ? {
          value: reputableDetails.registrationType,
          label: reputableDetails.registrationType,
        }
      : null
  );

  const [idList, setIdList] = useState([]);
  const [registrationType, setRegistrationType] = useState(reputableDetails !== null ? reputableDetails.registrationType : null);
  const [isReputable, setIsReputable] = useState(
    reputableDetails !== null
      ? reputableDetails.isReputablePerson === 0
        ? 0
        : 1
      : 0
  );

  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Add state for dropdown list
  const [DropdownList, setDropdownList] = useState([]);
  const [selectedList, setSelectedList] = useState(null);

  // Modal state for checkMpsAccount output 101 with responseData array
  const [showModal, setShowModal] = useState(false);
  const [modalLists, setModalLists] = useState([]);

  // Fetch Dropdown list from API
  const fetchDropdownList = async () => {
    try {
      const response = await axios({
        url: `${API_BASE_URL}/api/registration/fetchcontent`,
        method: "POST",
        data: {
          content_type: 4,
          api_key: "YouShallPass",
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        setDropdownList(
          response.data.data.map((item) => ({
            value: item.value,
            label: item.label,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to fetch dropdown list", error);
    }
  };

  const onSubmit = async (data) => {
    dispatchIDNumber(idNumber);
    _dispatchValidatedNumber(customerNumber);
    dispatchRegistrationType();
    dispatchUserDetails();
    dispatch(addIdType(idType, idName));

    await axios({
      url: `${API_BASE_URL}/api/registration/fetchcheckmsisdn`,
      method: "POST",
      data: {
        api_key: "YouShallPass",
        TID: idNumber,
        number: customerNumber,
        idType: idType,
        id: idNumber,
        api_key: "YouShallPass",
      },
    })
      .then(async (response) => {
        console.log('fetchcheck', response);
        const qualifies = response.data.data.qualifiesRegistration;
        if (qualifies === 1 || qualifies === 2) {
          // Call checkMpsAccount API before proceeding
          try {
            const checkMpsAccount = await axios({
              url: `${API_BASE_URL}/api/registration/checkMpsAccount`,
              method: "POST",
              data: {
                api_key: "YouShallPass",
                customerFirstName: firstName,
                customerSurName: lastName,
                customerDOB: dateOfBirth,
              },
            });
            // Handle responseSP 101 with responseData array
            if (
              checkMpsAccount.data && checkMpsAccount.data.responseSP === 101 && Array.isArray(checkMpsAccount.data.responseData)) {
              setModalLists(checkMpsAccount.data.responseData);
              setShowModal(true);
              return;
            }
            alert("No M-PAiSA Accounts Found");
            navigate("/userDetails");
          } catch (err) {
            alert("Failed to check MPS account. Please try again.");
          }
        } else if (qualifies === 2) {
          navigate("/userDetails");
        } else if (qualifies === 3) {
          alert("Cannot register customer exisiting! Please try again.");
        } else if (qualifies === 4) {
          alert("Exceeds Max registration limit");
        } else {
          alert("registration failed.");
        }
      })
      .catch((e) => {
        alert(
          "Cannot register customer! Please try again or contact customer care."
        );
      });
  };

  async function getIdList() {
    axios({
      url: `${API_BASE_URL}/api/registration/getIdList`,
      method: "POST",
      data: {
        api_key: "YouShallPass",
      },
    }).then((response) => {
      let list = response.data.data[0];
      let newList = list.map((ids) => {
        let newSet = {};
        newSet.value = ids.ID_Type;
        newSet.label = ids.ID_Name;
        return newSet;
      });

      if (ID_Type !== null) {
        let idFilter = newList.filter((id) => {
          if (id.value === idType) {
            return id;
          }
        });

        setSelectedIDType(idFilter[0]);
      }
      setIdList(newList);
    });
  }

  useEffect(() => {
    getIdList();
    fetchDropdownList();
  }, []);

  const saveValidateCustomerForm = () => {
    // let validateCustomerDetails = {};
    // validateCustomerDetails.Num = customerNumber;
    // validateCustomerDetails.ID = idNumber;
    // dispatch(getValidatedCustomerNumber(customerNumber));
    // dispatch(addIdNumber(idNumber));
    // dispatchIDNumber(idNumber);
    // _dispatchValidatedNumber(customerNumber);
    //dispatchRegistrationType();
    //dispatchUserDetails();
    //dispatch(addIdType(idType));
    //dispatch(validateCustomer(validateCustomerDetails))
  };

  const handleIDChange = (idType, idName) => {
    setIDType(idType.value);
    setIDName(idType.label);
    setSelectedIDType(idName);
  };

  const handleRegistrationChange = (e) => {
    setRegistrationType(e.value);
    setSelectedRegistrationType(e);
    // console.log(registrationType);
  };

  const _onChangeCusNumber = (cusNum) => {
    setCustomerNumber(cusNum);
  };

  const idNumberChange = (idNumber) => {
    setIdNumber(idNumber);
  };

    const handleDateChange = (value) => {
        console.log('dob',value)
      try {
        if (value) {
          let dob = moment(value.toISOString()).format("DD/MM/YYYY");
          console.log(dob);
          setDateOfBirth(dob);
        }
        setDisplayDOB(value);
      } catch (error) {
        console.error(error);
      }
    };
  

const dispatchUserDetails = () => {
    let customerDetails = {};
    customerDetails.cus_Num = customerNumber;
    customerDetails.id_Num = idNumber;
    customerDetails.firstName = firstName;
    customerDetails.lastName = lastName;
    customerDetails.dob = dob;
    //customerDetails.id_Name = idName;
    dispatch(addCustomerValidateDetails(customerDetails));
  };
  const dispatchRegistrationType = () => {
    let reputableDetailsAdd = {};
    let isReputableBinary = isReputable ? 1 : 0;
    reputableDetailsAdd.isReputablePerson = isReputableBinary;
    reputableDetailsAdd.registrationType = registrationType;

    dispatch(newSetRegistrationType(reputableDetailsAdd));
  };
  const _dispatchValidatedNumber = () => {
    dispatch(getValidatedCustomerNumber(customerNumber));
  };

  const dispatchIDNumber = () => {
    dispatch(addIdNumber(idNumber));
  };

  return (
    <Layout>
      {/* Modern Modal for output 101 with responseData array */}
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: 8,
            p: 2,
            background: "#f9f9fb",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: 22, color: "#222", pb: 1 }}>
          Existing M-PAiSA Accounts
        </DialogTitle>
        <DialogContent>
          {modalLists && modalLists.length > 0 ? (
            <List disablePadding>
              {modalLists.map((item, idx) => (
                <ListItem
                  key={idx}
                  sx={{
                    display: "block",
                    borderRadius: 2,
                    background: "#fff",
                    boxShadow: 1,
                    mb: 2,
                    p: 2,
                    border: "2px solid #dc3545", // red outline
                  }}
                >
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                    {Object.entries(item).map(([key, value]) => (
                      <Box
                        key={key}
                        sx={{
                          minWidth: 120,
                          mb: 1,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{ color: "#888", fontWeight: 500, letterSpacing: 0.5 }}
                        >
                          {key}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "#222", fontWeight: 600 }}
                        >
                          {String(value)}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography color="text.secondary" sx={{ py: 2 }}>
              No data found.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <button
            className="btn btn-danger"
            style={{
              borderRadius: "6px",
              padding: "8px 32px",
              fontWeight: 600,
              fontSize: "1rem",
              background: "#dc3545",
              color: "#fff",
              border: "none",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              cursor: "pointer"
            }}
            onClick={() => setShowModal(false)}
          >
            Back
          </button>
        </DialogActions>
      </Dialog>
      <div className="card-Pg3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <center>
              <h2 className="Auth-form-title">M-PAiSA Account Check</h2>
            </center>

            <label htmlFor="customerNumber" className="form-label">
              Customer Number
            </label>
            <input
              type="text"
              pattern="[0-9]*"
              value={customerNumber}
              {...register("customerNumber", { required: true, maxLength: 7 })}
              onChange={(input) => {
                _onChangeCusNumber(input.target.value);
              }}
              className="form-control"
              aria-describedby="emailHelp"
            />
            {errors.customerNumber && (
              <p className="text-error" style={{ fontSize: "12px" }}>
                Please check the Customer Number
              </p>
            )}
          </div>

          {/* First Name & Last Name Side by Side */}
          <div className="mb-3" style={{ display: "flex", gap: "1rem" }}>
            <div style={{ flex: 1 }}>
              <label htmlFor="firstName" className="form-label">
                First Name
              </label>
              <input
                type="text"
                value={firstName}
                {...register("firstName", { required: true })}
                onChange={(e) => setFirstName(e.target.value)}
                className="form-control"
              />
              {errors.firstName && (
                <p className="text-error" style={{ fontSize: "12px" }}>
                  Please enter First Name
                </p>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <label htmlFor="lastName" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                value={lastName}
                {...register("lastName", { required: true })}
                onChange={(e) => setLastName(e.target.value)}
                className="form-control"
              />
              {errors.lastName && (
                <p className="text-error" style={{ fontSize: "12px" }}>
                  Please enter Last Name
                </p>
              )}
            </div>
          </div>

          {/* Date of Birth */}
          <div className="mb-3" style={{ marginBottom: "2rem" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={displayDOB}
                inputFormat="DD/MM/YYYY"
                onChange={handleDateChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    error={!displayDOB}                    
                  />
                )}
              />
            </LocalizationProvider>
          </div>

          {/* ID Type */}
          <div className="mb-3">
            <label htmlFor="exampleInputEmail1" className="form-label">
              ID Type
            </label>
            <Select
              //  {...register("selectedIDType", { required: true })}
              onChange={(e) => handleIDChange(e)}
              options={idList}
              value={selectedIDType}
            />
          </div>

          {/* ID Number */}
          <div>
            <label htmlFor="exampleInputEmail1" className="form-label">
              ID Number
            </label>
            <input
              type="text"
              value={idNumber}
              {...register("idNumber", { required: true, maxLength: 12 })}
              onChange={(e) => idNumberChange(e.target.value)}
              className="form-control"
              aria-describedby="emailHelp"
            />
            {errors.idNumber && (
              <p className="text-error" style={{ fontSize: "12px" }}>
                Please check the ID Number
              </p>
            )}
            <FormControlLabel
              onChange={() => {
                setIsReputable(isReputable === 0 ? 1 : 0);
              }}
              control={<Checkbox size="small" />}
              label={<span style={{ fontSize: "15px" }}>{} "Register with Parent/Guardian/Endoser"</span>}
              checked={isReputable === 0 ? false : true}
            />
            {isReputable === 1 && (
              <div>
                <br />
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Registration Type
                </label>

                <Select
                  onChange={(e) => handleRegistrationChange(e)}
                  value={selectedRegistrationType}
                  options={[
                    { label: "Parent", value: 1 },
                    { label: "Guardian", value: 2 },
                    { label: "Endorser", value: 3 },
                  ]}
                />
              </div>
            )}
            <div className="spacing">
                    <Link to="/Registrationtype">
                      <button className="btn btn-danger">Back</button>
                    </Link>

                    <Button
                      className=" btn btn-danger"
                      type="submit"
                    >
                      Next
                    </Button>
              </div>
          </div>
        </Form>
      </div>
    </Layout>
  );
};

